export default __webpack_public_path__ + "static/media/Logo.4d6cfcdb.gif";